import type { Mark, SliderProps, ValueLabelProps } from '@material-ui/core';
import { Slider } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import React from 'react';
import { Field, useForm } from 'react-final-form';

const StyledSlider = withStyles({
  root: {
    height: 8,
    borderRadius: 4,
    '& .MuiSlider-thumb': {
      height: 24,
      width: 24,
      marginTop: -8,
      marginLeft: -12
    }
  },
  thumb: {
    backgroundColor: '#fff',
    border: '1px solid #02BD9C',
    '&:focus, &:hover, &$active': {
      boxShadow: '0px 1px 6px rgba(0, 0, 0, 0.320941)'
    }
  },
  mark: { display: 'none' },
  markLabel: {
    color: '#000',
    display: 'block !important',
    transform: 'translateX(-100%)',
    '&[data-index="0"]': {
      transform: 'none'
    }
  },
  active: {},
  valueLabel: {
    left: 'calc(-50% + 4px)',
    color: '#000'
  },
  track: {
    height: 8,
    borderRadius: 4,
    color: '#02BD9C',
    border: '1px solid #02BD9C'
  },
  rail: {
    height: 8,
    color: '#F5F5F5',
    border: '1px solid #EBEBEB',
    opacity: 1,
    borderRadius: 4
  }
})(Slider);

interface OwnProps {
  id: string;
  min: number;
  max: number;
  tooltip?: boolean;
  customTooltip?: React.ElementType<ValueLabelProps>;
  marks?: boolean | Mark[];
  disabled?: boolean;
}

type Props = OwnProps & SliderProps;

const Slide: React.FC<Props> = ({
  id,
  min,
  max,
  tooltip,
  customTooltip,
  marks,
  disabled,
  ...props
}) => {
  const form = useForm();

  return (
    <Field name={id}>
      {({ input: { value } }) => (
        <StyledSlider
          id={id}
          min={min}
          max={max}
          value={value ? parseInt(value) : min}
          disabled={disabled}
          valueLabelDisplay={customTooltip || tooltip ? 'auto' : 'off'}
          ValueLabelComponent={customTooltip}
          marks={marks}
          defaultValue={min}
          onChange={(_, val) => {
            form.change(id, val);
          }}
          {...props}
        />
      )}
    </Field>
  );
};

export default Slide;
